import styled from 'styled-components';

const FlexContainer = styled.div`
  gap: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  width: 100%;
`;

export default FlexContainer;
